import * as types from '../const/action.types';
import { get, put, post, del } from '../api/_basic';

export function all() {
    return async (dispatch) => {
        dispatch(localsHasErrored(false, ''));
        dispatch(localsIsLoading(true));
        return get(`${process.env.REACT_APP_API_LOCALS}`)
            .then((response) => {
                dispatch(localsIsLoading(false));
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return response;
            })
            .then((items) => {
                dispatch(localsHasErrored(false, ''));
                dispatch(loadlocalsSuccess(items));
            })
            .catch((error) => {
                dispatch(localsIsLoading(false));
                dispatch(localsHasErrored(error.type ? error.type : true, error.message));
            });
    };
}

export function add(local) {
    return async (dispatch) => {
        dispatch(localIsSaving(true));
        return post(`${process.env.REACT_APP_API_LOCAL}/${local.idLocal}/datosouilocal`, local)
            .then((response) => {
                dispatch(localIsSaving(false));
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return response;
            })
            .then((items) => {
                return true;
            })
            .catch((error) => {
                console.log(error);
                throw error;
            });
    };
}

export function edit(local) {
    return async (dispatch) => {
        dispatch(localIsSaving(true));
        return put(`${process.env.REACT_APP_API_LOCAL}/${local.idLocal}/datosouilocal`, local)
            .then((response) => {
                dispatch(localIsSaving(false));
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return response.data;
            })
            .then((items) => {
                return true;
            })
            .catch((error) => {
                console.log(error);
                throw error;
            });
    };
}

export function allLocalInfo() {
    return async (dispatch) => {
        dispatch(localsHasErrored(false, ''));
        dispatch(localsIsLoading(true));
        return get(`${process.env.REACT_APP_API_LOCAL}`)
            .then((response) => {
                dispatch(localsIsLoading(false));
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return response;
            })
            .then((items) => {
                dispatch(localsHasErrored(false, ''));
                dispatch(loadlocalsInfoSuccess(items));
            })
            .catch((error) => {
                dispatch(localsIsLoading(false));
                dispatch(localsHasErrored(error.type ? error.type : true, error.message));
            });
    };
}

export function editLocalInfo(local) {
    return async (dispatch) => {
        dispatch(localsIsLoading(true));
        return put(`${process.env.REACT_APP_API_LOCAL}/${local.id}`, local)
            .then((response) => {
                dispatch(localsIsLoading(false));
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return response.data;
            })
            .then((items) => {
                return true;
            })
            .catch((error) => {
                dispatch(localsIsLoading(false));
                console.log(error);
                throw error;
            });
    };
}

export function pauseLocal(local, time) {
    return async (dispatch) => {
        dispatch(localIsSaving(true));
        return put(`${process.env.REACT_APP_API_LOCAL}/${local}/pausaroui`, { minutos: time })
            .then((response) => {
                dispatch(localIsSaving(false));
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return response.data;
            })
            .then((items) => {
                return true;
            })
            .catch((error) => {
                console.log(error);
                throw error;
            });
    };
}

export function duplicated(from, to, isNew) {
    return async (dispatch) => {
        dispatch(localsIsLoading(true));
        var p1 = new Promise((resolve, reject) => {
            resolve(get(`${process.env.REACT_APP_API_LOCAL}/${from}/datosouilocal`));
            reject();
        });
        var p2 = new Promise((resolve, reject) => {
            resolve(get(`${process.env.REACT_APP_API}/tipomaquina`));
            reject();
        });
        const result = await Promise.all([from ? p1 : null, p2]).then((values) => {
            const local = values[0] ? values[0] : {};
            local._machinetypes = values[1];
            return local;
        });

        result.idLocal = to;
        if (isNew) {
            post(`${process.env.REACT_APP_API_LOCAL}/${result.idLocal}/datosouilocal`, result)
                .then(() => {
                    dispatch(localsIsLoading(false));
                    this.all();
                })
                .catch((error) => {
                    throw error;
                });
        } else {
            put(`${process.env.REACT_APP_API_LOCAL}/${result.idLocal}/datosouilocal`, result)
                .then(() => {
                    dispatch(localsIsLoading(false));
                    this.all();
                })
                .catch((error) => {
                    throw error;
                });
        }
    };
}

export function remove(local) {
    return async (dispatch) => {
        return del(`${process.env.REACT_APP_API_LOCAL}/${local}/datosouilocal`)
            .then((response) => {
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return true;
            })
            .catch((error) => {
                console.log(error);
                throw error;
            });
    };
}

export function load(local) {
    return async function(dispatch) {
        dispatch(localsHasErrored(false, ''));
        dispatch(localsIsLoading(true));
        dispatch(loadlocalSuccess({}));

        var p1 = new Promise((resolve, reject) => {
            resolve(get(`${process.env.REACT_APP_API_LOCAL}/${local}/datosouilocal`));
            reject();
        });
        var p2 = new Promise((resolve, reject) => {
            resolve(get(`${process.env.REACT_APP_API}/tipomaquina`));
            reject();
        });
        const result = await Promise.all([local ? p1 : null, p2]).then((values) => {
            const local = values[0] ? values[0] : {};
            local._machinetypes = values[1];
            return local;
        });

        if (result.error !== undefined) {
            dispatch(localsIsLoading(false));
            dispatch(localsHasErrored(result.type ? result.type : true, result.error));
        } else {
            dispatch(localsIsLoading(false));
            dispatch(localsHasErrored(false, ''));
            dispatch(loadlocalSuccess(result));
        }
    };
}

export function loadInfo(local) {
    return async function(dispatch) {
        dispatch(localsHasErrored(false, ''));
        dispatch(localsIsLoading(true));
        dispatch(loadlocalInfoSuccess({}));
        return get(`${process.env.REACT_APP_API_LOCAL}/${local}`)
            .then((response) => {
                dispatch(localsIsLoading(false));
                return response;
            })
            .then((item) => {
                if (item.error !== undefined) {
                    dispatch(localsHasErrored(item.type ? item.type : true, item.error));
                } else {
                    dispatch(localsHasErrored(false, ''));
                    dispatch(loadlocalInfoSuccess(item));
                }
            })
            .catch((error) => {
                dispatch(localsIsLoading(false));
                dispatch(localsHasErrored(error.type ? error.type : true, error.message));
            });
    };
}

export function loadlocalSuccess(data) {
    return {
        type: types.LOAD_LOCAL_SUCCESS,
        data,
    };
}

export function loadlocalInfoSuccess(data) {
    return {
        type: types.LOAD_LOCAL_INFO_SUCCESS,
        data,
    };
}

export function loadlocalsSuccess(data) {
    return {
        type: types.LOCALS_SUCCESS,
        data,
    };
}

export function loadlocalsInfoSuccess(data) {
    return {
        type: types.LOCALS_INFO_SUCCESS,
        data,
    };
}

export function localsHasErrored(bool, message) {
    return {
        type: types.LOCALS_HAS_ERROR,
        hasErrored: bool,
        error: message,
    };
}

export function localsIsLoading(bool) {
    return {
        type: types.LOCALS_IS_LOADING,
        isLoading: bool,
    };
}

export function localIsSaving(bool) {
    return {
        type: types.LOCALS_IS_SAVING,
        isLoading: bool,
    };
}



// WEBPACK FOOTER //
// ./src/actions/locals.actions.js